import React from 'react'
import styled from 'styled-components'

import { database } from '../../firebase'

import AdminItem from './AdminItem'

import arrowUp from '../../images/icons/arrow-up-small.png'
import arrowDown from '../../images/icons/arrow-down-small.png'

const Title = styled.span`
  position: relative;
  padding-left: 2.6rem;

  img {
    position: absolute;
    left: 0;
    width: 26px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.6;
  }

  .admin-item-title-arrow-up {
    top: -1rem;
  }

  .admin-item-title-arrow-down {
    bottom: -1rem;
  }
`

export default class AdminContentListen extends React.Component {
  constructor() {
    super()
    this.handleArrowClick = this.handleArrowClick.bind(this)
  }
  handleArrowClick(direction, pos) {
    const { data } = this.props
    const ref = database.ref('listen')

    let current = data[pos].val().order
    let url = data[pos].key
    let prevUrl, nextUrl

    if (pos !== 0) {
      let val = pos - 1
      prevUrl = data[val].key
    }

    if (pos !== data.length - 1) {
      let val = pos + 1
      nextUrl = data[val].key
    }

    for (let i = 0, l = data.length; i < l; i++) {
      if (direction === 'up' && current === i) {
        ref.child(`${url}/order`).set(i - 1)
        ref.child(`${prevUrl}/order`).set(i)
      }

      if (direction === 'down' && current === i) {
        ref.child(`${url}/order`).set(i + 1)
        ref.child(`${nextUrl}/order`).set(i)
      }
    }
  }
  render() {
    const { edit, link, remove, totalLinks } = this.props
    const pos = link.val().order
    return (
      <AdminItem remove={remove} edit={edit} dbRef={link.ref} param="listen" itemTitle="Listen">
        <Title className="admin-item-title">
          {pos !== 0 && (
            <img
              className="admin-item-title-arrow-up"
              onClick={() => this.handleArrowClick('up', pos)}
              src={arrowUp}
              alt="move up"
            />
          )}
          {pos !== totalLinks - 1 && (
            <img
              className="admin-item-title-arrow-down"
              onClick={() => this.handleArrowClick('down', pos)}
              src={arrowDown}
              alt="move down"
            />
          )}
          <strong>{link.val().title}</strong>
        </Title>
      </AdminItem>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminContentListen.js